import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { InterfaceService } from '@app/interfaces';
var IntegrationsService = /** @class */ (function (_super) {
    tslib_1.__extends(IntegrationsService, _super);
    function IntegrationsService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.loadingStepEmitter = new EventEmitter();
        _this.continueButtonEmitter = new EventEmitter();
        _this.deleteIntegration = new EventEmitter();
        _this.hideSidePanel = new EventEmitter();
        _this.clearSearchBoxEmitter = new EventEmitter();
        _this.continueButtonStatusEmitter = new EventEmitter();
        _this.SFG20connectionMethodEvent = new EventEmitter();
        return _this;
    }
    IntegrationsService.prototype.hideSidePanelFunction = function () {
        this.hideSidePanel.emit(true);
    };
    IntegrationsService.prototype.loadingStep = function (data) {
        this.loadingStepEmitter.emit(data);
    };
    IntegrationsService.prototype.sendContinueButtonAction = function (data) {
        this.continueButtonEmitter.emit(data);
    };
    IntegrationsService.prototype.continueButtonStatus = function (status) {
        this.continueButtonStatusEmitter.emit(status);
    };
    IntegrationsService.prototype.clearMainSearchBox = function () {
        this.clearSearchBoxEmitter.emit(true);
    };
    IntegrationsService.prototype.callDeleteIntegration = function (name) {
        this.deleteIntegration.emit(name);
    };
    IntegrationsService.prototype.sendSFG20ConnectionMethod = function (name) {
        this.SFG20connectionMethodEvent.emit(name);
    };
    IntegrationsService.prototype.connectCalendar = function (params) {
        return this.http
            .post(this.getApiUrl("oauthCalendar"), { calendar: params });
    };
    IntegrationsService.prototype.setupCalendar = function (params) {
        var body = new URLSearchParams();
        body.set('code', params.code);
        body.set('state', params.state);
        body.set('session_state', params.session_state);
        body.set('calendarType', params.calendarType);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl("setupCalendarIntegation"), body.toString(), options);
    };
    IntegrationsService.prototype.getCalendarAccountDetails = function () {
        return this.http
            .get(this.getApiUrl("getCalendarAccountDetails"));
    };
    IntegrationsService.prototype.checkCalendarAccountExist = function (params) {
        return this.http
            .get(this.getApiUrl("checkCalendarAccountExist", params));
    };
    IntegrationsService.prototype.disconnectCalendar = function (params) {
        var body = new URLSearchParams();
        body.set('calendar', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('checkCalendarAccountExist'), body.toString(), options);
    };
    IntegrationsService.prototype.generateZapierToken = function (params) {
        var body = new URLSearchParams();
        body.set('application', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('integrations/createAuthToken'), body.toString(), options);
    };
    IntegrationsService.prototype.getZappierToken = function (params) {
        var body = new URLSearchParams();
        body.set('application', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('integrations/getAuthToken'), body.toString(), options);
    };
    IntegrationsService.prototype.getAllIntegrationsdata = function (screen) {
        if (screen == "Settings") {
            return this.http
                .get(this.getApiUrl("getAllSettingsDetails?screen=" + screen));
        }
        else {
            return this.http
                .get(this.getApiUrl("getAllIntegrationsDetails?screen=" + screen));
        }
    };
    IntegrationsService.prototype.getZapierAccountDetails = function (params) {
        var body = new URLSearchParams();
        body.set('application', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('integrations/getZapierAccountDetails'), body.toString(), options);
    };
    IntegrationsService.prototype.disconnectZapier = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('status', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('integrations/disconnectZapierIntegration'), body.toString(), options);
    };
    IntegrationsService.prototype.checkWolseleySetupExists = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        // body.set('accountNumber', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("checkWolseleySetupExist/" + params.accountNumber + "?type=" + params.integrationName), options);
    };
    IntegrationsService.prototype.getOpportunityrelatedinfo = function () {
        var body = new URLSearchParams();
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getOpportunityInfo"), options);
    };
    IntegrationsService.prototype.validatHeatengineerAccount = function (params) {
        var body = new URLSearchParams();
        body.set('otp', params['otp']);
        body.set('email', params['email']);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl("validatHeatengineerAccount"), body.toString(), options);
    };
    IntegrationsService.prototype.getlist_templates = function () {
        var body = new URLSearchParams();
        body.set('parentId', '');
        body.set('search', '');
        body.set('screen', 'opportunity_template');
        body.set('type', '');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('list_templates'), body.toString(), options);
    };
    IntegrationsService.prototype.searchResults = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('page', '');
        body.set('limit', '');
        body.set('pageTab', '');
        body.set('q', params);
        body.set('type', 'suppliers');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('searchResults'), body.toString(), options);
    };
    IntegrationsService.prototype.getSupplierBranches = function (params, thirdparty) {
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getSupplierBranches/" + params + "?page=1&limit=5&thirdparty=" + thirdparty + "&searchText="), options);
    };
    IntegrationsService.prototype.setupWolseleyAccount = function (params, branchesData) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('wolseley[thirdpartyname]', params.integrationName);
        body.set('wolseley[supplierId]', params.id);
        body.set('wolseley[accountNo]', params.accountNumber);
        body.set('wolseley[userName]', params.userName);
        body.set('wolseley[pwd]', params.pwd);
        body.set('wolseley[postcode]', params.postcode);
        body.set('wolseley[telephone]', params.telephone);
        for (var branch in branchesData) {
            body.set("branchesData[" + branch + "]", branchesData[branch]);
        }
        console.log(body.toString());
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('setupWolseleyAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.SetupSpruceAccount = function (params) {
        var body = new URLSearchParams();
        body.set('spruce[opportunityTemplate]', params.opportunityTemplate);
        body.set('spruce[reportingLine]', params.reportingLine);
        body.set('spruce[salesPersons]', params.salesPersons);
        body.set('spruce[advertisingtype]', params.advertisingtype);
        body.set('spruce[pipeline]', params.pipeline);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('setupSpruceAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.SetupHeatEngineerAccount = function (params) {
        var body = new URLSearchParams();
        body.set('heatEngineer[accountNumber]', params.accountNumber);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('setupHeatEngineerAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.getSaleIntegrationsAccountData = function (params) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getSaleIntegrationsAccountData"), options);
    };
    IntegrationsService.prototype.updateSpruceAccount = function (params) {
        var body = new URLSearchParams();
        body.set('spruce[opportunityTemplate]', params.opportunityTemplate);
        body.set('spruce[reportingLine]', params.reportingLine);
        body.set('spruce[salesPersons]', params.salesPersons);
        body.set('spruce[advertisingtype]', params.advertisingtype);
        body.set('spruce[pipeline]', params.pipeline);
        body.set('spruce[accountId]', params.id);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('updateSpruceAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.updateHeatEngineerAccount = function (params) {
        var body = new URLSearchParams();
        body.set('heatEngineer[accountNumber]', params.accountNumber);
        body.set('heatEngineer[accountId]', params.id);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('updateHeatEngineerAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.getWolseleyBranches = function (params, thirdparty) {
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getWolseleyBranches?thirdparty=" + thirdparty + "&searchText=&supplierId=" + params), options);
    };
    IntegrationsService.prototype.getWolseleyAccountData = function (params) {
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getWolseleyAccountData?page=1&limit=5&searchText="), options);
    };
    IntegrationsService.prototype.updateWolseleyDetails = function (params, accountNumber, otherParams) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('wolseley[thirdpartyname]', params['thirdpartyName']);
        body.set('wolseley[supplierId]', params['supplierId']);
        body.set('wolseley[status]', params['status']);
        body.set('wolseley[id]', params['id']);
        body.set('wolseley[accountNo]', accountNumber);
        //alert(JSON.stringify(otherParams));
        if (otherParams) {
            body.set('wolseley[userName]', otherParams['userName']);
            body.set('wolseley[pwd]', otherParams['pwd']);
            body.set('wolseley[postcode]', otherParams['postcode']);
            body.set('wolseley[telephone]', otherParams['telephone']);
        }
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('updateWolseleyDetails'), body.toString(), options);
    };
    IntegrationsService.prototype.deleteWolseleyAccount = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('id', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('deleteWolseleyAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.setSupplierId = function (id) {
        this.id = id;
        console.log('in set method: id is ' + this.id);
    };
    IntegrationsService.prototype.getSupplierId = function () {
        console.log('in get method: id is ' + this.id);
        return this.id;
    };
    IntegrationsService.prototype.searchJdpResults = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('q', 'properties:' + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('searchJdpResults'), body.toString(), options);
    };
    IntegrationsService.prototype.checkSetupExists = function (params) {
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("checkSetupExist/" + params + "?type=jdp"), options);
    };
    IntegrationsService.prototype.setupRRS = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('jdp[rrsname]', params.rrsname);
        body.set('jdp[apitoken]', params.apiToken);
        body.set('jdp[property]', params.propertyId);
        body.set('jdp[port]', params.port);
        body.set('jdp[sftp]', params.sftp);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('setupRRS'), body.toString(), options);
    };
    IntegrationsService.prototype.getRRSData = function (params) {
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getRRSData?page1&limit=5"), options);
    };
    IntegrationsService.prototype.deleteRRS = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('jdp[rrsId]', params.rrsId);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('deleteRRS'), body.toString(), options);
    };
    IntegrationsService.prototype.connectPipedrive = function (params) {
        return this.http
            .get(this.getApiUrl("getPipedriveConfig?newUI=1"));
    };
    IntegrationsService.prototype.connectHubspot = function (params) {
        return this.http
            .get(this.getApiUrl("getHubspotConfig?newUI=1"));
    };
    IntegrationsService.prototype.getFields = function (type, accountId) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.get(this.getApiUrl("getFieldMapping?type=" + type + "&crmAccId=" + accountId + "&page=1" + "&limit=5&searchText=", options));
        //.get(this.getApiUrl(`getFieldMapping?type=pipedrive&crmAccId=`+params.accountId+`&page=1`+`&limit=5&searchText=`+ encodeURIComponent(params.search)), options);
    };
    IntegrationsService.prototype.checkCRMAccountExist = function (params) {
        return this.http
            .get(this.getApiUrl("getCRMAccountDetails"));
    };
    IntegrationsService.prototype.cancelIntegration = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('confirmText', 'CANCEL' + undefined);
        body.set('moduleValue[moduleId]', undefined);
        body.set('moduleValue[jobtodos]', undefined);
        body.set('UI', 'newUI');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('cancel_integration?type=MailChimp'), body.toString(), options);
    };
    IntegrationsService.prototype.mailchimpConnect = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('APIkey', params);
        body.set('UI', 'newUI');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('mailchimp_connect'), body.toString(), options);
    };
    IntegrationsService.prototype.checkMailChimpAccountExists = function (params) {
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("integrations/checkMailChimpAccountExists"), options);
    };
    IntegrationsService.prototype.generateWebhookUrl = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('naturalform/createwebhooks'), body.toString(), options);
    };
    IntegrationsService.prototype.getWebHooks = function (params) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('naturalform/webhooks'), body.toString(), options);
    };
    IntegrationsService.prototype.changeCalendarStatus = function (params, type) {
        var body = new URLSearchParams();
        // console.log("params is :" + params);
        body.set('status', params);
        body.set('type', type);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('changeCalendarStatus'), body.toString(), options);
    };
    IntegrationsService.prototype.getCalendarUsers = function (type, search) {
        return this.http
            .get(this.getApiUrl('getCalendarAccountLists?type=' + type + "&search=" + search));
    };
    IntegrationsService.prototype.setupPipedriveAccount = function (details, accountId) {
        var body = new URLSearchParams();
        // console.log("params is :" + JSON.stringify(details));
        body.set('preferencesDetails', JSON.stringify(details));
        body.set('accountId', accountId);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        //alert(this.getApiUrl('setupPipedriveAccount'));
        return this.http.post(this.getApiUrl('setupPipedriveAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.setupHubspotAccount = function (details, accountId) {
        var body = new URLSearchParams();
        // console.log("params is :" + JSON.stringify(details));
        body.set('preferencesDetails', JSON.stringify(details));
        body.set('accountId', accountId);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        //alert(this.getApiUrl('setupPipedriveAccount'));
        return this.http.post(this.getApiUrl('setupHubspotAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.saveFieldMapping = function (accountId, details, rowToDelete, showManage) {
        var body = new URLSearchParams();
        // console.log("params is :" + JSON.stringify(details));
        body.set('fieldsData', JSON.stringify(details));
        body.set('crmAccountId', accountId);
        body.set('rowToDelete', JSON.stringify(rowToDelete));
        body.set('isManage', showManage);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        //alert(this.getApiUrl('setupPipedriveAccount'));
        return this.http.post(this.getApiUrl('saveFieldsMapping'), body.toString(), options);
    };
    IntegrationsService.prototype.deleteCRMAccount = function (type) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        if (type == 'pipedrive') {
            return this.http.post(this.getApiUrl('deletePipedriveAccount'), '', options);
        }
        else {
            return this.http.post(this.getApiUrl('deleteHubspotAccount'), '', options);
        }
    };
    IntegrationsService.prototype.addNaturalformTemplate = function (templateName, templateId) {
        var body = new URLSearchParams();
        //// console.log("params is :" + JSON.stringify(details));
        body.set('customcertificate[description]', templateId);
        body.set('customcertificate[name]', templateName);
        body.set('customcertificate[type]', 'Naturalforms');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        //alert(this.getApiUrl('setupPipedriveAccount'));
        return this.http.post(this.getApiUrl('naturalform/addtemplates'), body.toString(), options);
    };
    IntegrationsService.prototype.getNaturalFormTemplate = function (param) {
        return this.http
            .get(this.getApiUrl('naturalform/gettemplates', param));
    };
    IntegrationsService.prototype.editNaturalformTemplate = function (id, templateName, templateId) {
        var body = new URLSearchParams();
        //// console.log("params is :" + JSON.stringify(details));
        body.set('customcertificate[description]', templateId);
        body.set('customcertificate[name]', templateName);
        body.set('customcertificate[id]', id);
        body.set('customcertificate[type]', 'Naturalforms');
        body.set('customcertificate[ui]', 'new');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        //alert(this.getApiUrl('setupPipedriveAccount'));
        return this.http.put(this.getApiUrl('naturalform/edittemplates'), body.toString(), options);
    };
    IntegrationsService.prototype.deleteNaturalFormTemplate = function (id) {
        var body = new URLSearchParams();
        //// console.log("params is :" + JSON.stringify(details));
        body.set('customcertificate[id]', id);
        body.set('customcertificate[ui]', 'new');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        //alert(this.getApiUrl('setupPipedriveAccount'));
        return this.http.post(this.getApiUrl('naturalform/deletetemplates'), body.toString(), options);
    };
    IntegrationsService.prototype.disconnectNaturalForm = function () {
        var body = new URLSearchParams();
        body.set('action', 'disconnect');
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('naturalform/disconnect'), body.toString(), options);
    };
    IntegrationsService.prototype.searchIntegration = function (param, screen) {
        if (screen == 'Settings') {
            return this.http
                .get(this.getApiUrl('getAllSettingsDetails', { searchText: param }));
        }
        else {
            return this.http
                .get(this.getApiUrl('getAllIntegrationsDetails', { searchText: param }));
        }
    };
    IntegrationsService.prototype.getCreditCard = function () {
        return this.http
            .get(this.getApiUrl('credit_card_details', { newUI: 1 }));
    };
    IntegrationsService.prototype.callStripeLocations = function () {
        return this.http
            .get(this.getApiUrl('get_stripe_locations', { newUI: 1 }));
    };
    IntegrationsService.prototype.getCreditCardDetails = function () {
        return this.http
            .get(this.getApiUrl('credit_card_details', { newUI: 1 })).toPromise();
    };
    IntegrationsService.prototype.getPaymentMethod = function () {
        return this.http
            .get(this.getApiUrl('listPaymentMethods', { newUI: 1 }));
    };
    IntegrationsService.prototype.updateCreditCardPaymentMethod = function (paymentMethod) {
        var body = new URLSearchParams();
        body.set('paymentMethod', JSON.stringify(paymentMethod));
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.put(this.getApiUrl('add_creditcard_paymentmethods'), body.toString(), options);
    };
    IntegrationsService.prototype.updateNominalCodeStripeMethod = function (nominalcodes) {
        var body = new URLSearchParams();
        body.set('nominalcodes', JSON.stringify(nominalcodes));
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.put(this.getApiUrl('add_nominal_code_stripe'), body.toString(), options);
    };
    IntegrationsService.prototype.updateMotoPaymentStripeMethod = function (motopaymentMethod) {
        var body = new URLSearchParams();
        body.set('motopaymentMethod', JSON.stringify(motopaymentMethod));
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.put(this.getApiUrl('add_motopayment_stripe'), body.toString(), options);
    };
    IntegrationsService.prototype.getalreadySelectedPaymentMethod = function (paymentMethodId) {
        if (paymentMethodId) {
            return this.http
                .get(this.getApiUrl('checkPaymentMethod', { newUI: 1, paymentMethodID: paymentMethodId }));
        }
    };
    IntegrationsService.prototype.deleteCreditCardIntegration = function (type) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        body.set('confirmText', 'CANCEL');
        return this.http.post(this.getApiUrl('cancel_credit_card?mode=' + type + "&newUI=1"), body.toString(), options);
    };
    IntegrationsService.prototype.connectWorldpay = function (clientKey, serviceKey) {
        var body = new URLSearchParams();
        body.set('clientKey', clientKey);
        body.set('serviceKey', serviceKey);
        body.set('newUI', "1");
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('worldpay_connect'), body.toString(), options);
    };
    IntegrationsService.prototype.connectBasys = function (apiKey, validate) {
        var body = new URLSearchParams();
        body.set('apiKey', apiKey);
        body.set('action', validate);
        body.set('newUI', "1");
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('basys_connect'), body.toString(), options);
    };
    IntegrationsService.prototype.disconnectJDPAccount = function (params) {
        var body = new URLSearchParams();
        body.set('rrsId', params);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('deleteRRS'), body.toString(), options);
    };
    IntegrationsService.prototype.updateRRS = function (params) {
        var body = new URLSearchParams();
        body.set('jdp[rrsname]', params.rrsname);
        body.set('jdp[apitoken]', params.apiToken);
        body.set('jdp[property]', params.propertyId);
        body.set('jdp[rrsId]', params.rrsId);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl('updateRRS'), body.toString(), options);
    };
    IntegrationsService.prototype.savePreferences = function (params) {
        var body = new URLSearchParams();
        body.set('value', params.value);
        body.set('key', params.key);
        body.set('secret', params.secret);
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .post(this.getApiUrl("saveSFG20Method"), body.toString(), options);
    };
    IntegrationsService.prototype.addTemplate = function (id, sync) {
        if (sync === void 0) { sync = false; }
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("addTemplate/" + id + "?sync=" + sync), options);
    };
    IntegrationsService.prototype.getTemplates = function (query) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        query = !query ? '' : query;
        return this.http
            .get(this.getApiUrl("system_settings/list-ppm?searchText=" + query + "&type=SFG20"), options);
    };
    IntegrationsService.prototype.getSFG20Status = function () {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getStatus"), options);
    };
    IntegrationsService.prototype.isPPMDelete = function (id) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("ppm/" + id + "/is-ppm-delete"), options);
    };
    IntegrationsService.prototype.deletePPM = function (id) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .delete(this.getApiUrl("ppm/" + id + "/delete"), options);
    };
    IntegrationsService.prototype.syncAllPPM = function () {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("syncAllPPM"), options);
    };
    IntegrationsService.prototype.processFiles = function (fileNames) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        var parsedFiles = JSON.stringify(fileNames);
        body.set('fileNames', parsedFiles);
        return this.http
            .post(this.getApiUrl("processXMLFiles"), body.toString(), options);
    };
    IntegrationsService.prototype.disconnectSFG20integration = function () {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("disconnectSFG20Integration"), options);
    };
    IntegrationsService.prototype.listSFG20Files = function () {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("listFiles"), options);
    };
    IntegrationsService.prototype.deleteSFG20XMLFile = function (id) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("deleteXMLFile/" + id), options);
    };
    IntegrationsService.prototype.getSchedulesData = function () {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http
            .get(this.getApiUrl("getScheduleData"), options);
    };
    IntegrationsService.prototype.sendFeedbackToSlackChannel = function (feedbackData) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        body.set('feedback', feedbackData['feedback']);
        body.set('reason', feedbackData['reason']);
        body.set('uiScreen', feedbackData['uiScreen']);
        return this.http
            .post(this.getApiUrl("sendFeedbackData"), body.toString(), options);
    };
    IntegrationsService.prototype.deleteDirectDebitIntegration = function (type) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        body.set('confirmText', 'CANCEL');
        return this.http.post(this.getApiUrl('gocardless_disconnect?mode=' + type + "&newUI=1"), body.toString(), options);
    };
    IntegrationsService.prototype.updateGocardless = function (creditor, type) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        if (type == "creditor") {
            body.set('creditor', creditor);
        }
        else if (type == "payment") {
            body.set('payment', JSON.stringify(creditor));
        }
        else {
            body.set('nominalcode', JSON.stringify(creditor));
        }
        return this.http.post(this.getApiUrl('gocardless_update'), body.toString(), options);
    };
    IntegrationsService.prototype.connectHitachi = function (clientKey, serviceKey, branchId) {
        var body = new URLSearchParams();
        body.set('clientKey', clientKey);
        body.set('secretKey', serviceKey);
        body.set('branchId', branchId);
        body.set('newUI', "1");
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('hitachi_connect'), body.toString(), options);
    };
    IntegrationsService.prototype.connectHitachiDetails = function (retailerName, tradingName, privacyPolicy, clientKey, serviceKey, branchId) {
        var body = new URLSearchParams();
        body.set('retailerName', retailerName);
        body.set('tradingName', tradingName);
        body.set('privacyPolicy', privacyPolicy);
        body.set('clientKey', clientKey);
        body.set('secretKey', serviceKey);
        body.set('branchId', branchId);
        body.set('newUI', "1");
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('hitachi_connectadditionalinfo'), body.toString(), options);
    };
    IntegrationsService.prototype.updateHitachiDetails = function (clientKey, serviceKey, branchId) {
        var body = new URLSearchParams();
        body.set('clientKey', clientKey);
        body.set('secretKey', serviceKey);
        body.set('branchId', branchId);
        body.set('newUI', "1");
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('hitachi_connect'), body.toString(), options);
    };
    IntegrationsService.prototype.deleteHitachiIntegration = function (type) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        body.set('confirmText', 'CANCEL');
        return this.http.post(this.getApiUrl('hitachi_disconnect?mode=' + type + "&newUI=1"), body.toString(), options);
    };
    IntegrationsService.prototype.deleteSpruceIntegration = function (params) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        console.log("params is :" + params);
        body.set('id', params);
        body.set('confirmText', 'CANCEL');
        return this.http.post(this.getApiUrl('deleteSpruceAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.deleteHeatAccount = function (params) {
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        var body = new URLSearchParams();
        body.set('id', params);
        body.set('confirmText', 'CANCEL');
        return this.http.post(this.getApiUrl('deleteHeatAccount'), body.toString(), options);
    };
    IntegrationsService.prototype.addRepresentativeDetails = function (retailerName, tradingName, privacyPolicy, clientKey, serviceKey, branchId, representativeDetails) {
        var body = new URLSearchParams();
        body.set('retailerName', retailerName);
        body.set('tradingName', tradingName);
        body.set('privacyPolicy', privacyPolicy);
        body.set('clientKey', clientKey);
        body.set('secretKey', serviceKey);
        body.set('branchId', branchId);
        body.set('representativeDetails', representativeDetails);
        body.set('newUI', "1");
        var options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(this.getApiUrl('hitachi_addRepresentative'), body.toString(), options);
    };
    return IntegrationsService;
}(InterfaceService));
export { IntegrationsService };
